import React from 'react'

interface UsageInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export const UsageInfoModal: React.FC<UsageInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-2">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg border border-slate-200">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-base font-semibold text-slate-800">Jak korzystać z kalendarza</h2>
          <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm font-medium rounded-md border-2 border-red-500 text-red-600 bg-white hover:bg-red-50 transition-colors">Zamknij</button>
        </div>
        <div className="px-5 py-4 text-slate-700">
          <ul className="list-disc pl-5 space-y-3 text-sm">
            <li>
              <span className="font-semibold text-sky-600">Pojedyncze kliknięcie</span> w nieoznaczony dzień <span className="font-semibold text-emerald-600">przypisuje opiekę</span> do opiekuna wybranego w nawigacji na górze strony (Opiekun A / Opiekun B).
            </li>
            <li>
              <span className="font-semibold text-sky-600">Pojedyncze kliknięcie</span> w dzień, który ma już opiekę, notatkę lub koszt — tylko <span className="font-semibold text-emerald-600">zaznacza ten dzień</span> i pokazuje listę wpisów pod kalendarzem.
            </li>
            <li>
              <span className="font-semibold text-sky-600">Dwuklik</span> w dzień <span className="font-semibold text-emerald-600">otwiera panel</span> przypisania opieki / dodania notatki/kosztu (w planach Pro/Max). Zamiast dwukliku możesz też użyć przycisku <span className="font-semibold text-emerald-600">„Dodaj”</span>.
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default UsageInfoModal


